import { render, staticRenderFns } from "./HeadLineImage.vue?vue&type=template&id=2fbf6ba8&scoped=true&"
import script from "./HeadLineImage.vue?vue&type=script&lang=js&"
export * from "./HeadLineImage.vue?vue&type=script&lang=js&"
import style0 from "./HeadLineImage.vue?vue&type=style&index=0&id=2fbf6ba8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fbf6ba8",
  null
  
)

export default component.exports